import { useEffect } from 'react';

import { useSelectedLoggedInUsersAccesses } from 'Deer/slice/UserAccessesSlice';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import userflow from 'userflow.js';

import { getUsefulTrackingDataFromLoggedInEmployee } from 'constants/mixpanel';

const useUserflow = () => {
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);
  const { adminAccesses: employeeAccesses } = useSelectedLoggedInUsersAccesses() ?? {};
  const {
    organizationId,
    organizationName,
    organizationStatus,
    planType,
    loggedInEmployeeId,
    loggedInEmployeeEmail,
    fullName,
    enabledFeatures,
  } = getUsefulTrackingDataFromLoggedInEmployee(loggedInEmployee);

  useEffect(() => {
    if (process.env.PUBLIC_APP_ENABLE_USERFLOW !== 'true') return;

    if (loggedInEmployeeId && loggedInEmployeeEmail && fullName) {
      userflow.init(process.env.PUBLIC_APP_USERFLOW_TOKEN);
      userflow.setResourceCenterLauncherHidden(true);
      userflow.identify(loggedInEmployeeId, {
        name: fullName,
        email: loggedInEmployeeEmail,
        organization_id: organizationId,
        organization_name: organizationName,
        organization_status: organizationStatus,
        organization_plantype: planType,
        employee_access: employeeAccesses,
        // todo: remove
        is_rabbit_ui: true,
        enabled_features: enabledFeatures,
      });
    }
  }, [
    loggedInEmployeeId,
    loggedInEmployeeEmail,
    fullName,
    organizationId,
    organizationName,
    organizationStatus,
    planType,
    employeeAccesses,
    enabledFeatures,
  ]);
};

export default useUserflow;
